import React from "react";
import { Form } from "rsuite";

const PermanentAddress = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Province</Form.ControlLabel>
        <Form.Control name="Province" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>District</Form.ControlLabel>
        <Form.Control name="District" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Municipality</Form.ControlLabel>
        <Form.Control name="Municipality" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Permanent Street Name</Form.ControlLabel>
        <Form.Control name="PermanentStreetName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Permanent Street Name (Nepali)</Form.ControlLabel>
        <Form.Control name="PermanentStreetName(Nepali)" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Permanent House No.</Form.ControlLabel>
        <Form.Control name="PermanentHouseNo" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Permanent Ward No.</Form.ControlLabel>
        <Form.Control name="PermanentWardNo" type="number" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Permanent Location</Form.ControlLabel>
        <Form.Control name="PermanentLocation" />
      </Form.Group>
    </div>
  );
};

export default PermanentAddress;
